export const BAM_SUBSCRIPTION_PRICES: Record<number, Record<number, string>> = {
  1: {
    1: "9.99",
    6: "56.99",
    12: "107.99",
  },
  5: {
    1: "14.99",
    6: "85.99",
    12: "161.99",
  },
  10: {
    1: "19.99",
    6: "113.99",
    12: "215.99",
  },
  20: {
    1: "39.99",
    6: "227.99",
    12: "431.99",
  },
};
